import React, { useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/courses/CoursesAction";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { CourseEditForm } from "./CourseEditForm";

export function CourseEdit({
  history,
  match: {
    params: { id, parentId }
  }
}) {
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, course } = useSelector(
    (state) => ({
      actionsLoading: state.courses.actionsLoading,
      isSuccess: state.courses.isSuccess,
      type: state.courses.type,
      course: state.courses.course
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getCourse(id, parentId));
    return () => dispatch(actions.cleanCoursesState());
  }, [id, parentId, dispatch]);
  
  const saveCourse = (values) => {
    dispatch(actions.saveCourse(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/dersler`), 2500);
  };

  const btnRef = useRef();  
  const saveCourseClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  let title= "Ders";
  let action = id ? "Düzenle" : "Ekle";
  title += " " + action;
  title = <> {title} {course.parentId ? <> (Ana Ders: <span style={{color:"red"}}>{course.parentCourse}</span>)</>: ""} </>

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <CourseEditForm 
            course={course}
            btnRef={btnRef} 
            saveCourse={saveCourse}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveCourseClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}